import axios from "axios";

import {
  Document,
  HeadingLevel,
  Packer,
  Paragraph,
  TextRun,
  Table,
  TableRow,
  TableCell,
  WidthType,
  AlignmentType,
  BorderStyle,
} from "docx";
// import * as XLSX from "xlsx";
import * as XLSX from "xlsx-js-style";
import { pdf } from "@react-pdf/renderer";
import { saveAs } from "file-saver";
import { useSelector } from "react-redux";

const theme = localStorage.getItem("theme")

const API_KEY = process.env.REACT_APP_GOOGLE_API_KEY;
// --------------------------------------------------------------------

export const getSumOfObjectValue = (obj) => {
  if (!obj || typeof obj !== "object" || Object.keys(obj).length === 0) {
    return 0; // agar obj undefined, null ya empty object hai to 0 return karo
  }

  const total = Object.values(obj).reduce((sum, value) => {
    const num = Number(value);
    return sum + (isNaN(num) ? 0 : num);
  }, 0);

  return total;
  // const total = Object.values(obj).reduce((sum, value) => sum + value, 0);
  // return total
}

export const currentFynencialYear = () => {
  const now = new Date();
  const month = now.getMonth() + 1; // 1..12
  const year = now.getFullYear();

  // determine current FY (India style Apr-Mar)
  const currentFyStart = month >= 4 ? year : year - 1;
  const currentFyYear = `${currentFyStart}-${(currentFyStart + 1)
    .toString()
    .slice(-2)}`;

  return currentFyYear
}

export const indianLoaclStrigNumber = (value) => {
  if (value === null || value === undefined || value === '') return '';
  const normalized = String(value).trim().replace(/,/g, '');
  const num = Number(normalized);
  if (!isFinite(num)) return String(value);
  try {
    return num.toLocaleString('en-IN');
  } catch (e) {
    // fallback same as earlier
    const sign = num < 0 ? '-' : '';
    const absNum = Math.abs(num);
    const parts = String(absNum).split('.');
    let intPart = parts[0];
    const decPart = parts[1] ? '.' + parts[1] : '';
    if (intPart.length > 3) {
      const last3 = intPart.slice(-3);
      let rest = intPart.slice(0, -3);
      rest = rest.replace(/\B(?=(\d{2})+(?!\d))/g, ',');
      intPart = rest + ',' + last3;
    }
    return sign + intPart + decPart;
  }
}

export const normalNumber = (formatted) => {
  return Number(formatted.replace(/,/g, ''));
}

export const useSelect = (key) => { return useSelector((state) => state[key]) };

export const isValidIndianFormattedNumber = (value) => {
  if (value === null || value === undefined) return false;

  const str = String(value).trim();

  // Empty string invalid
  if (str === "") return false;

  // Strict regex for Indian formatted or plain numbers only
  const pattern = /^(\d{1,3}(,\d{2})*(,\d{3})|\d+)$/;

  return pattern.test(str);
}

export const formatDateWithLongMonth = (dateInput, format = "DD MMMM, YYYY") => {
  const date = new Date(dateInput);

  const map = {
    DD: String(date.getDate()).padStart(2, "0"),
    D: date.getDate(),
    MMMM: date.toLocaleString("en-US", { month: "long" }),
    MMM: date.toLocaleString("en-US", { month: "short" }),
    MM: String(date.getMonth() + 1).padStart(2, "0"),
    M: date.getMonth() + 1,
    YYYY: date.getFullYear(),
    YY: String(date.getFullYear()).slice(-2),
  };

  return format.replace(/DD|D|MMMM|MMM|MM|M|YYYY|YY/g, matched => map[matched]);
}

export const getGreterDate = (date1_, date_2) => {
  const date1 = new Date(date1_);
  const date2 = new Date(date_2);

  let res = ""

  if (date1 > date2) {
    res = "date1";
  } else if (date1 < date2) {
    res = "date2";
  } else {
    res = "both";
  }
  return res
}

export const formatDateToMonthYear = (dateString) => {
  const date = new Date(dateString);
  const options = { month: "long", year: "numeric" };
  return date.toLocaleDateString("en-US", options).replace(" ", "-");
};

export const monthNames = [
  "January",
  "February",
  "March",
  "April",
  "May",
  "June",
  "July",
  "August",
  "September",
  "October",
  "November",
  "December",
];

const shortMonthNames = [
  "Jan",
  "Feb",
  "Mar",
  "Apr",
  "May",
  "Jun",
  "Jul",
  "Aug",
  "Sep",
  "Oct",
  "Nov",
  "Dec",
];

const dayNames = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"];

// Helper to format date


// utils/numberUtils.js

/**
 * Checks whether input is a valid Indian number format
 * (e.g. "12,90,889" or "1290889")
 */
export const isValidIndianNumber = (value) => {
  if (value === undefined || value === null) return false;

  const str = String(value).trim();

  // Allow only digits and commas
  if (!/^[0-9,]*$/.test(str)) return false;

  // Empty allowed while typing (so that delete works)
  if (str === "") return true;

  // Progressive check – allow incomplete typing like 1234, 12,34 etc.
  if (/^\d{1,3}(,\d{0,2})*(,?\d*)?$/.test(str)) return true;

  return false;
}


export const formatDate = (isoDateStr) => {
  const date = new Date(isoDateStr);
  const options = { month: "short", day: "2-digit" }; // Aug-02
  return date.toLocaleDateString("en-US", options).replace(" ", "-");
};

export const compressImage = (file, quality, maxWidth, callback) => {
  const reader = new FileReader();

  reader.readAsDataURL(file);

  reader.onload = function (event) {
    const img = new Image();
    img.src = event.target.result;

    img.onload = function () {
      const canvas = document.createElement("canvas");
      const ctx = canvas.getContext("2d");

      let width = img.width;
      let height = img.height;

      if (width > maxWidth) {
        height = Math.round((maxWidth / width) * height);
        width = maxWidth;
      }

      canvas.width = width;
      canvas.height = height;

      ctx.drawImage(img, 0, 0, width, height);

      const compressedDataUrl = canvas.toDataURL("image/jpeg", quality);

      callback(compressedDataUrl);
    };
  };

  reader.onerror = function (error) { };
};

export const scrollBottom = (id) => {
  const scrollContainer = document.getElementById(id);
  if (scrollContainer) {
    scrollContainer.scrollTo({
      top: scrollContainer.scrollHeight,
      left: 0,
    });
  }
};

export const getDayName = (day) => {
  var days = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"];

  return days[day];
};

export const getDaysInMonth = (year, month) => {
  const days = [];

  const monthNames = [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December",
  ];

  const date = new Date(year, month - 1, 1);

  const monthName = monthNames[month - 1];

  while (date.getMonth() === month - 1) {
    days.push({
      date: date.getDate(),
      day: date.toLocaleDateString("en-US", { weekday: "short" }),
      month: monthName,
    });
    date.setDate(date.getDate() + 1);
  }

  return days;
};

export const months = [
  "January",
  "February",
  "March",
  "April",
  "May",
  "June",
  "July",
  "August",
  "September",
  "October",
  "November",
  "December",
];

export const splitMonthIntoWeeks = (data) => {
  let weeks = [];
  let currentWeek = [];

  data?.forEach((day) => {
    if (day.day === "Sun" && currentWeek.length > 0) {
      weeks.push([...currentWeek]);
      currentWeek = [];
    }
    currentWeek.push(day);
  });

  if (currentWeek.length > 0) {
    weeks.push([...currentWeek]);
  }

  return weeks;
};

export const getMonthDatesFormatted = (year, month) => {
  const dates = [];
  const today = new Date();

  const isCurrentMonth =
    year === today.getFullYear() && month === today.getMonth();

  const totalDays = isCurrentMonth
    ? today.getDate()
    : new Date(year, month + 1, 0).getDate();

  for (let date = 1; date <= totalDays; date++) {
    const current = new Date(year, month, date);
    const day = dayNames[current.getDay()];
    const fullDate = `${date} ${shortMonthNames[month]}, ${year}`;

    const mainDate = date < 10 ? `0${date}` : date;
    const mainMonth = month < 10 ? `0${month}` : month;

    dates.push({
      day: day,
      date: date,
      month: monthNames[month],
      fullDate: `${year}-${mainMonth}-${mainDate}`,
      fullDateWithMonth: fullDate,
    });
  }

  return dates;
};

export const toProperCase = (text) =>
  text
    .replace(/([A-Z])/g, " $1")
    .replace(/^./, (str) => str.toUpperCase())
    .trim();

export const getFormattedPaymentHistory = (payment) => {
  let newObj = {};
  const transformedArr = payment.map((item) => ({
    ...item,
    ...item.allowance_list[0],
    ...item.newallowance_list[0], // allowance_list array ka first object
    allowance_list: undefined, // agar "address" field hatani ho
  }));

};

export const getFormattedAttendance = (attendance) => {
  return attendance.map((item) => {
    const dateObj = new Date(item.date);
    const day = dateObj.getDate();
    const month = dateObj.toLocaleString("default", { month: "long" });
    const dayName = dateObj.toLocaleString("default", { weekday: "short" });

    const options = {
      weekday: "long",
      day: "2-digit",
      month: "long",
      year: "numeric",
    };
    const parts = new Intl.DateTimeFormat("en-GB", options).formatToParts(
      dateObj
    );

    const formattedDate = `${parts.find((p) => p.type === "weekday").value}, ${parts.find((p) => p.type === "day").value
      } ${parts.find((p) => p.type === "month").value}, ${parts.find((p) => p.type === "year").value
      }`;

    return {
      fullDate: formattedDate,
      date: day,
      day: dayName,
      month: month,
      checkInTime: item.checkInTime == undefined ? "-" : item.checkInTime,
      checkOutTime: item.checkOutTime == undefined ? "-" : item.checkOutTime,
      duration: item.duration == undefined ? "-" : item.duration,
      isPresent: item.isPresent ? "Present" : "Absent",
      isHoliday:
        item.isHoliday == undefined ? "-" : item.isHoliday ? "Holiday" : "-",
      isWeekOffOrHoliday:
        item.isWeekOff == undefined ? "-" : item.isWeekOff ? "Week Off" : "-",
      reason: item.reason,
    };
  });
};

export const getFormattedMonthlyAttendance = (attendance) => {
  return attendance?.map((item) => {
    const dateObj = new Date(item.dates);
    const day = dateObj.getDate();
    const month = dateObj.toLocaleString("default", { month: "long" });
    const dayName = dateObj.toLocaleString("default", { weekday: "short" });

    const options = {
      weekday: "long",
      day: "2-digit",
      month: "long",
      year: "numeric",
    };
    const parts = new Intl.DateTimeFormat("en-GB", options).formatToParts(
      dateObj
    );

    const formattedDate = ` ${parts.find((p) => p.type === "day").value} ${parts.find((p) => p.type === "month").value
      }, ${parts.find((p) => p.type === "year").value}`;

    return {
      fullDate: formattedDate,
      date: day,
      day: dayName,
      month: month,
      fullDateWithMonth: formattedDate,
      statusCode: item.statusCode,
      status: item.status,
    };
  });
};

export const getFormattedAttendanceCSV = (attendance) => {
  return attendance.map((item) => {
    const dateObj = new Date(item.date);
    const day = dateObj.getDate();
    const month = dateObj.toLocaleString("default", { month: "long" });
    const dayName = dateObj.toLocaleString("default", { weekday: "long" });

    const options = {
      weekday: "long",
      day: "2-digit",
      month: "long",
      year: "numeric",
    };
    const parts = new Intl.DateTimeFormat("en-GB", options).formatToParts(
      dateObj
    );

    const formattedDate = `${parts.find((p) => p.type === "weekday").value}, ${parts.find((p) => p.type === "day").value
      } ${parts.find((p) => p.type === "month").value}, ${parts.find((p) => p.type === "year").value
      }`;

    return {
      date: day,
      day: dayName,
      month: month,
      isPresent: item.isPresent ? "Present" : "Absent",
      checkInTime: item.checkInTime == undefined ? "-" : item.checkInTime,
      checkOutTime: item.checkOutTime == undefined ? "-" : item.checkOutTime,
      duration: item.duration == undefined ? "-" : item.duration,
      isWeekOffOrHoliday:
        item.isWeekOff == undefined ? "-" : item.isWeekOff ? "Week Off" : "-",
      reason: item.reason,
    };
  });
};

export const getFormattedUsers = (attendance) => {
  return attendance.map((item) => {
    return {
      staffId: item.staffId,
      staffName: item.staffName,
      employeeId: item.employeeId,
      punchIn:
        item.punchIn == undefined || item.punchIn == null || item.punchIn == ""
          ? "-"
          : item.punchIn,
      punchOut:
        item.punchOut == undefined ||
          item.punchOut == null ||
          item.punchOut == ""
          ? "-"
          : item.punchOut,
      expectedIn:
        item.expectedIn == undefined ||
          item.expectedIn == null ||
          item.expectedIn == ""
          ? "-"
          : item.expectedIn,
      expectedOut:
        item.expectedOut == undefined ||
          item.expectedOut == null ||
          item.expectedOut == ""
          ? "-"
          : item.expectedOut,
      totalWorkHours:
        item.totalWorkHours == undefined ||
          item.totalWorkHours == null ||
          item.totalWorkHours == ""
          ? "-"
          : item.totalWorkHours,
      status: item.status,
    };
  });
};

export const getEmployeeFormattedData = (data) => {
  return data.map((val, index) => {
    return {
      "S.No": index + 1,
      "Employee Role": val.emp_role || "-",
      "Employee Id": val.employee_id || "-",
      "Name": val.full_name || val.name || "-",
      "Job Title": val.job_title || "-",
      "Gender": val.gender || "-",
      "Official Email": val.official_email || "-",
      "Personal Email": val.personal_email || "-",
      "Mobile Number": val.mobile_number || "-",
      "Date Of Birth": val.dob || "-",
      "Date Of Join": val.date_of_join || "-",
      "Marital Status": val.marital_status || "-",
      "Blood Group": val.blood_group || "-",
      "Address": val.addressDetails?.address || "-",
      "Aadhar Name": val.governmentIds?.aadhar_name || "-",
      "Aadhar Number": val.governmentIds?.aadhar_number || "-",
      "ESI Number": val.governmentIds?.esi_number || "-",
      "PAN Name": val.governmentIds?.pan_name || "-",
      "PAN Number": val.governmentIds?.pan_number || "-",
      "PF Number": val.governmentIds?.pf_number || "-",
      "UAN Number": val.governmentIds?.uan_number || "-",
      "Emergency Contact Name": val.addressDetails?.emergencyContactName || "-",
      "Emergency Contact Number": val.addressDetails?.emergencyContactNumber || "-",
      "Emergency Contact Relation": val.addressDetails?.emergencyContactRelation || "-",
      "Status": val.status == 1 ? "Active" : "InActive"
    };
  });
};

export const getEmployeeFormattedDataOne = (data, type) => {
  let array;
  if (type == 1) {
    array = data.map((val) => {
      return {
        Name:
          val.full_name == undefined
            ? val.name == undefined
              ? "-"
              : val.name
            : "-",
        "Job Title":
          val.job_title == undefined ||
            val.job_title == null ||
            val.job_title == ""
            ? "-"
            : val.job_title,
        "Schedule Type": val.schedule_type ? val.schedule_type : "-",
        "Shift Name": val.shiftName ? val.shiftName : "-",
        Status: val.status == 1 ? "Active" : "InActive",
      };
    });
  }
  if (type == 2) {
    array = data.map((val) => {
      return {
        name: val.name,
        "Job Title": val.job_title,
        "Bank Name": val.bankName ? val.bankName : "-",
        "Account Number": val.accountNumber ? val.accountNumber : "-",
        "IFSC Code": val.ifscCode ? val.ifscCode : "-",
        "Bank Branch": val.bankBranch ? val.bankBranch : "-",
        status: val.status ? (val.status == "1" ? "Active" : "InActive") : "-",
      };
    });
  }

  if (type == 3) {
    array = data.map((val) => {
      return {
        fullName: val.full_name,
        employeeId: val.employee_id,
        jobTitle: val.job_title,
        mobileNumber: val.mobileNumber,
        branchNames: val.branchNames,
        otherAllowances: val.salaryBreakup.otherAllowances,
        otherAllowancesYearly: val.salaryBreakup.otherAllowancesYearly,
        basicPay: val.salaryBreakup.basicPay,
        basicPayYearly: val.salaryBreakup.basicPayYearly,
        hraPay: val.salaryBreakup.hraPay,
        hraPayYearly: val.salaryBreakup.hraPayYearly,
        employeePf: val.salaryBreakup.employeePf,
        employeePfYearly: val.salaryBreakup.employeePfYearly,
        employeeEsi: val.salaryBreakup.employeeEsi,
        employeeEsiYearly: val.salaryBreakup.employeeEsiYearly,
        professionalTax: val.salaryBreakup.professionalTax,
        professionalTaxYearly: val.salaryBreakup.professionalTaxYearly,
        employerPf: val.salaryBreakup.employerPf,
        employerPfYearly: val.salaryBreakup.employerPfYearly,
        employerEsi: val.salaryBreakup.employerEsi,
        employerEsiYearly: val.salaryBreakup.employerEsiYearly,
        employerEdli: val.salaryBreakup.employerEdli,
        employerEdliYearly: val.salaryBreakup.employerEdliYearly,
        adminCharges: val.salaryBreakup.adminCharges,
        adminChargesYearly: val.salaryBreakup.adminChargesYearly,
        grossSalary: val.salaryBreakup.grossSalary,
        grossSalaryYearly: val.salaryBreakup.grossSalaryYearly,
        netSalary: val.salaryBreakup.netSalary,
        netSalaryYearly: val.salaryBreakup.netSalaryYearly,
        lwfAmount: val.salaryBreakup.lwfAmount,
        lwfAmountYearly: val.salaryBreakup.lwfAmountYearly,
        employerLwfAmount: val.salaryBreakup.employerLwfAmount,
        employerLwfAmountYearly: val.salaryBreakup.employerLwfAmountYearly,
        employeePFText: val.salaryBreakup.employeePFText,
        totalEmployeeContributions:
          val.salaryBreakup.totalEmployeeContributions,
        totalEmployeeContributionsYearly:
          val.salaryBreakup.totalEmployeeContributionsYearly,
        totalEmployerContributions:
          val.salaryBreakup.totalEmployerContributions,
        totalEmployerContributionsYearly:
          val.salaryBreakup.totalEmployerContributionsYearly,
        costToCompany: val.salaryBreakup.costToCompany,
        costToCompanyYearly: val.salaryBreakup.costToCompanyYearly,
      };
    });
  }

  if (type == 4) {
    array = data.map((val) => {
      return {
        name: val.name,
        jobTitle: val.job_title,
        "Casual Leave": val["Casual Leave"],
        "Sick Leave": val["Sick Leave"],
        "Other Leave": val["Other Leave"],
      };
    });
  }

  if (type == 5) {
    array = data.map((val) => {
      return {
        employeeId: val.employeeId,
        name: val.staffName,
        jobTitle: val.jobTitle,
        branch: val.branchName,
        departmentName: val.departmentName,
        role: val.roleName,
        status: val.status == "1" ? "Active" : "InActive"
      };
    });
  }

  if (type == 6) {
    array = data.map((val) => {
      return {
        employeeId: val.employeeId,
        staffName: val.staffName,
        jobTitle: val.jobTitle,
        payrollModelId: val.payrollModelId,
        payrollMonthYear: val.payrollMonthYear,
        grossAmount: val.grossAmount,
        grossMonthlyOrYearly: val.grossMonthlyOrYearly,
        costToCompany: val.costToCompany,
        payrollType: val.payrollType,
        basicPay: val.basicPay,
        hraPay: val.hraPay,
        otherAllowance: val.otherAllowance,
        payableDays: val.payableDays,
        presentDays: val.presentDays,
        absentDays: val.absentDays,
        employeePf: val.employeePf,
        employeeEsi: val.employeeEsi,
        professionalTax: val.professionalTax,
        totalAllowanceAmount: val.totalAllowanceAmount,
        employerPf: val.employerPf,
        employerEsi: val.employerEsi,
        edliCharges: val.edliCharges,
        adminCharges: val.adminCharges,
        employee_lwf: val.employee_lwf,
        employer_lwf: val.employer_lwf,
        payDaysCount: val.payDaysCount,
        advanceAmount: val.advanceAmount,
        workBasicAmount: val.workBasicAmount,
        bonusAmount: val.bonusAmount,
        incentiveAmount: val.incentiveAmount,
        reimburseAmount: val.reimburseAmount,
        otherEarningsAmount: val.otherEarningsAmount,
        otherDeductionsAmount: val.otherDeductionsAmount,
        grossSalary: val.grossSalary,
        netSalary: val.netSalary,
        netTakeHomeSalary: val.netTakeHomeSalary,
        paid: val.paid,
        totalEmployeeContributions: val.totalEmployeeContributions,
        totalEmployerContributions: val.totalEmployerContributions,
        totalProfessionalTax: val.totalProfessionalTax,
        totalTaxDeductedAtSource: val.totalTaxDeductedAtSource,
        totalLoanAmountGiven: val.toalLoanAmountGiven,
        totalLoanAmountTaken: val.totalLoanAmountTaken,
        pendingLoanAmount: val.pendingLoanAmount,

        finalizedPayroll: val.finalizedPayroll,
        finalizedDate: val.finalizedDate,
        status: val.status == "1" ? "Active" : "InActive",
      };
    });
  }

  if (type == 7) {
    array = data.map((val) => {
      return {};
    });
  }

  return array;
};

// const convertToCSV___ = (array) => {
//   const formatHeader = (header) => {
//     return header
//       .replace(/([a-z])([A-Z])/g, "$1 $2")
//       .replace(/(^\w|\s\w)/g, (match) => match.toUpperCase());
//   };

//   const headers =
//     Object.keys(array[0])
//       .map((header) => `"${formatHeader(header)}"`)
//       .join(",") + "\n";

//   const rows = array
//     .map((row) =>
//       Object.values(row)
//         .map((value) => `"${value}"`)
//         .join(",")
//     )
//     .join("\n");

//   return headers + rows;
// };

export const formattedAttDashboard = (data) => {
  return data.map((val) => {
    return {
      "Staff Name": val.staffName,
      "Phone Number": val.mobileNumber,
      "Employee ID": val.employeeId,
      "Job Title": val.jobTitle,
      Present: val.attendanceSummary?.Present,
      Absent: val.attendanceSummary?.Absent,
      "Half Day": val.attendanceSummary?.["Half Day"],
      "Week Off": val.attendanceSummary?.["WeekOff"],
      Holiday: val.attendanceSummary?.Holiday,
      "Paid Leave": val.attendanceSummary?.["Paid Leave"],
      "Unpaid Leave": val.attendanceSummary?.["Un Paid Leave"],
      "Overtime On Working Day":
        val.attendanceSummary?.["Overtime On Working Day"],
      "Overtime On Week Off": val.attendanceSummary?.["Overtime On Week Off"],
      "Late Coming": val.attendanceSummary?.["Late CheckIn"],
      "Early Leaving": val.attendanceSummary?.["Early CheckOut"],
    };
  });
};

// const convertToCSV = (array) => {
//   const formatHeader = (header) => {
//     return header
//       .replace(/([a-z])([A-Z])/g, "$1 $2")
//       .replace(/(^\w|\s\w)/g, (match) => match.toUpperCase());
//   };

//   const headers =
//     Object.keys(array[0])
//       .map((header) => `"${formatHeader(header)}"`)
//       .join(",") + "\n";

//   const rows = array
//     .map((row) =>
//       Object.values(row)
//         .map((value) =>
//           value === "" || value === null || value === undefined
//             ? `"-"`
//             : `"${value}"`
//         )
//         .join(",")
//     )
//     .join("\n");

//   return headers + rows;
// };

export const formatHeader = (header) => {
  return header
    .replace(/([a-z])([A-Z])/g, "$1 $2")
    .replace(/(^\w|\s\w)/g, (match) => match.toUpperCase());
};

export const convertToCSV = (array) => {
  // const formatHeader = (header) => {
  //   return header
  //     .replace(/([a-z])([A-Z])/g, "$1 $2")
  //     .replace(/(^\w|\s\w)/g, (match) => match.toUpperCase());
  // };

  // // Get original headers and add "S.No" as first column
  // const originalHeaders = Object.keys(array[0]);
  // const headersWithSNo = ["S.No", ...originalHeaders];

  // // Format headers for CSV
  // const headers =
  //   headersWithSNo.map((header) => `"${formatHeader(header)}"`).join(",") +
  //   "\n";

  // // Generate rows with serial numbers
  // const rows = array
  //   .map((row, index) => {
  //     // Add serial number as first value
  //     const valuesWithSNo = [index + 1, ...Object.values(row)];

  //     return valuesWithSNo
  //       .map((value) =>
  //         value === "" || value === null || value === undefined
  //           ? `"-"`
  //           : `"${value}"`
  //       )
  //       .join(",");
  //   })
  //   .join("\n");

  // return headers + rows;

  const originalHeaders = Object.keys(array[0]);
  const headersWithSNo = ["S.No", ...originalHeaders];

  const headers =
    headersWithSNo.map((header) => `"${formatHeader(header)}"`).join(",") +
    "\n";

  const rows =
    array
      .map((row, index) => {
        const values = [
          index + 1,
          ...originalHeaders.map((key) => {
            let value = row[key];
            if (value === "" || value === null || value === undefined) {
              return '"-"';
            }
            const str = String(value).replace(/"/g, '""'); // Escape quotes
            return `"${str}"`;
          }),
        ];

        return values.join(",");
      })
      .join("\n") + "\n";

  return headers + rows;
};

export const getAttendanceFormattedData = (data) => {
  const arr = data?.map(({ attendanceSummary, OvertimeHours, ...rest }) => ({
    ...rest,
    ...attendanceSummary,
    ...OvertimeHours,
  }));
  return arr;
};

export function flattenObject(obj, parentKey = "", result = {}) {
  for (let key in obj) {
    const propName = parentKey ? `${parentKey}.${key}` : key;

    if (
      typeof obj[key] === "object" &&
      obj[key] !== null &&
      !Array.isArray(obj[key])
    ) {
      // Nested object
      flattenObject(obj[key], propName, result);
    } else if (Array.isArray(obj[key])) {
      // Array
      obj[key].forEach((item, index) => {
        if (typeof item === "object" && item !== null) {
          // Nested object in array
          flattenObject(item, `${propName}[${index}]`, result);
        } else {
          result[`${propName}[${index}]`] = item;
        }
      });
    } else {
      result[propName] = obj[key];
    }
  }
  return result;
}

export function flattenObjectToSingleCell(obj, parentKey = "", result = {}) {
  for (let key in obj) {
    const propName = parentKey ? `${parentKey}_${key}` : key;

    if (typeof obj[key] === "object" && obj[key] !== null) {
      // Instead of flattening, put entire object/array as JSON
      result[propName] = JSON.stringify(obj[key]);
    } else {
      result[propName] = obj[key];
    }
  }
  return result;
}

export const csvDataWithNestedObject = (dataArray) => {
  // Flatten all data
  // const flattened = dataArray.map(item => flattenObject(item));

  // // Create a unique set of headers
  // const headersSet = new Set();
  // flattened.forEach(item => {
  //   Object.keys(item).forEach(key => headersSet.add(key));
  // });
  // const headers = Array.from(headersSet);

  // // Generate CSV rows
  // const rows = flattened.map(item =>
  //   headers.map(header => (item[header] !== undefined ? `"${item[header]}"` : '""')).join(',')
  // );

  // // Final CSV string
  // const csvData = [headers.join(','), ...rows].join('\n');

  const flattened = dataArray.map((item) => flattenObjectToSingleCell(item));

  const headersSet = new Set();
  flattened.forEach((item) => {
    Object.keys(item).forEach((key) => headersSet.add(key));
  });
  const headers = Array.from(headersSet);

  const rows = flattened.map((item) =>
    headers
      .map((header) =>
        item[header] !== undefined ? `"${item[header]}"` : '""'
      )
      .join(",")
  );

  const csvData = [headers.join(","), ...rows].join("\n");

  const blob = new Blob([csvData], { type: "text/csv" });
  const link = document.createElement("a");
  link.href = window.URL.createObjectURL(blob);
  link.download = "monthly_report_";
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
};

export const downloadCSV = (data, name = "data.csv") => {
  const csvData = convertToCSV(data);
  const blob = new Blob([csvData], { type: "text/csv" });
  const url = window.URL.createObjectURL(blob);

  const link = document.createElement("a");
  link.href = url;
  link.download = name;
  link.click();

  window.URL.revokeObjectURL(url);
};

export const formattedReport = (data) => {
  return data.map((val, idx) => {
    return {
      "Staff Name": val.staffName,
      "Employee Id": val.employeeId,
      "Branch Name": val.branchName,
      Date: val.date,
      "Punch In": val.punchIn,
      "Punch Out": val.punchOut,
      "Start Latitude": val.startLatitude,
      "Start Longitude": val.startLongitude,
      "Stop Latitude": val.stopLatitude,
      "Stop Longitude": val.stopLongitude,
      "Total Work Hours": val.totalWorkHours,
      "Check In Location": val.checkInLocation,
      "Check Out Location": val.checkOutLocation,
      "Expected In": val.expectedIn,
      "Expected Out": val.expectedOut,
      Status: val.status,
      "Made By": val.madeBy,
    };
  });
};

export const downloadCSV1 = (data, name = "data.csv") => {
  const csv = convertToCSV(data);
  const blob = new Blob([csv], { type: "text/csv" });
  const url = URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url;
  a.download = name;
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
  return csv;
};

export const convertJSONToCSV = (jsonData) => {
  if (!jsonData.length) return "";

  const headers = Object.keys(jsonData[0]).join(",");

  const rows = jsonData.map((obj) =>
    Object.values(obj)
      .map((value) =>
        value === "" || value === null || value === undefined ? "-" : value
      )
      .join(",")
  );

  return [headers, ...rows].join("\n");
};

export const dropdownFunc = () => {
  const selectedAll = document.querySelectorAll(".wrapper_dropdown");

  selectedAll.forEach((selected) => {
    const optionsList = selected.querySelectorAll("div.wrapper_dropdown li");

    selected.addEventListener("click", () => {
      let arrow = selected.children[1];

      let classList = selected.classList;

      if (classList.contains("active")) {
        handleDropdown(selected, arrow, false);
      } else {
        let currentActive = document.querySelector(".wrapper_dropdown.active");

        if (currentActive) {
          let anotherArrow = currentActive.children[1];
          handleDropdown(currentActive, anotherArrow, false);
        }

        handleDropdown(selected, arrow, true);
      }
    });

    for (let o of optionsList) {
      o.addEventListener("click", () => {
        selected.querySelector(".selected-display").innerHTML = o.innerHTML;
      });
    }
  });

  window.addEventListener("click", function (e) {
    if (e.target.closest(".wrapper_dropdown") === null) {
      closeAllDropdowns();
    }
  });

  function closeAllDropdowns() {
    const selectedAll = document.querySelectorAll(".wrapper_dropdown");
    selectedAll.forEach((selected) => {
      const optionsContainer = selected.children[2];
      let arrow = selected.children[1];

      handleDropdown(selected, arrow, false);
    });
  }

  function handleDropdown(dropdown, arrow, open) {
    if (open) {
      arrow.classList.add("rotated");
      dropdown.classList.add("active");
    } else {
      arrow.classList.remove("rotated");
      dropdown.classList.remove("active");
    }
  }
};

export const checkLength = (e) => {
  if (e.target.value.length === e.target.maxLength) {
    e.stopPropagation();
    e.preventDefault();
    return false;
  }
  return true;
};

export const convertPDFToBase64 = (pdfFile) => {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();

    reader.onload = () => {
      const base64String = reader.result.split(",")[1];
      resolve("data:application/pdf;base64," + base64String);
    };

    reader.onerror = (error) => {
      reject(error);
    };

    reader.readAsDataURL(pdfFile);
  });
};

export const customStyles = {
  headCells: {
    style: {
      borderBottom: "2px solid #000",
      fontWeight: "bold",
    },
  },
};

export const ISOTimeFormat = (time) => {
  const date = new Date(time);
  const options = {
    timeZone: "Asia/Kolkata",
    weekday: "short",
    year: "numeric",
    month: "short",
    day: "numeric",
    hour: "2-digit",
    minute: "2-digit",
    second: "2-digit",
    hour12: false,
  };

  const formattedDate = date.toLocaleString("en-US", options).replace(",", "");
  const timeZoneName = date
    .toLocaleTimeString("en-US", {
      timeZone: "Asia/Kolkata",
      timeZoneName: "shortOffset",
    })
    .split(" ")[2];
  const formattedTime = `${formattedDate} ${timeZoneName} (India Standard Time)`;
  return formattedTime;
};

export const getFileExtension = (url) => {
  const lastDotIndex = url.lastIndexOf(".");
  if (lastDotIndex !== -1) {
    return url.substring(lastDotIndex);
  }
  return null;
};

export const getCurrentDate = () => {
  const currentDate = new Date();
  const date = currentDate.getDate().toString().padStart(2, "0");
  const month = (currentDate.getMonth() + 1).toString().padStart(2, "0");
  const year = currentDate.getFullYear();
  const mainDate = `${year}-${month}-${date}`;
  return mainDate;
};

export const getFormattedToday = () => {
  const d = new Date();
  return `${d.getDate()} ${d.toLocaleString("en-US", {
    month: "short",
  })} ${d.getFullYear()}`;
};

export const getFormattedDate = (date) => {
  const d = new Date(date);
  return `${d.getDate()} ${d.toLocaleString("en-US", {
    month: "short",
  })} ${d.getFullYear()}`;
};

export const getCapitalizeWord = (string) => {
  if (string) {
    const output = string.replace(/\b\w/g, (char) => char.toUpperCase());
    return output;
  }
  return null;
};

export const geolocationStatus = async () => {
  if (!navigator.geolocation) {
    return "not supported by your browser";
  }

  try {
    const result = await navigator.permissions.query({ name: "geolocation" });

    if (result.state === "granted") {
      return "granted";
    } else if (result.state === "denied") {
      return "denied";
    } else if (result.state === "prompt") {
      return "prompt";
    }
  } catch (error) {
    console.error("Error checking location permission:", error);
    return "error";
  }
};

export const splitWaypoints = (allWaypoints) => {
  const chunks = [];
  for (let i = 0; i < allWaypoints.length; i += 99) {
    const sliceArray = allWaypoints.slice(i, i + 99);

    const newArr = sliceArray
      .map((row) => {
        return `${parseFloat(row.latitude)},${parseFloat(row.longitude)}`;
      })
      .join("|");
    chunks.push(newArr);
  }
  return chunks;
};

export const getUniqueLocations = (locations) => {
  const uniqueSet = new Set();
  return locations
    .filter((item) => {
      const key = `${item.location.latitude}-${item.location.longitude}-${item.placeId}`;
      if (uniqueSet.has(key)) {
        return false;
      } else {
        uniqueSet.add(key);
        return true;
      }
    })
    .map((item) => ({
      latitude: item.location.latitude,
      longitude: item.location.longitude,
    }));
};

// const getSnapToRoadsWayPoints = async (array) => {
//   const accurateData = [];
//   await array.map((row) => {
//     let path = "https://roads.googleapis.com/v1/snapToRoads?path=";
//     let endPath = `&interpolate=true&key=${API_KEY}`;
//     let url = path + row + endPath;
//     axios
//       .get(url)
//       .then((response) => {
//         accurateData.push(response.data.snappedPoints);
//       })
//       .catch((error) => {
//         console.log(error);
//       });
//   });
//   return accurateData;
// };

export const getSnapToRoadsWayPoints = async (array) => {
  const promises = array.map(async (row) => {
    let path = "https://roads.googleapis.com/v1/snapToRoads?path=";
    let endPath = `&interpolate=true&key=${API_KEY}`;
    let url = path + row + endPath;

    try {
      const response = await axios.get(url);
      return response.data.snappedPoints; // यह nested array return करता है
    } catch (error) {
      console.log(error);
      return [];
    }
  });

  const accurateData = await Promise.all(promises);
  return accurateData.flat(); // सभी inner arrays को एक ही array में बदल देगा
};

export const splitCamelCase = (str) => {
  return str
    .replace(/(\d+)([A-Za-z])/g, "$1 $2") // Numbers aur letters ke beech space
    .replace(/([a-z])([A-Z])/g, "$1 $2");
};

export const getInitials = (fullName) => {
  if (!fullName) return "";
  const name = fullName
    .split(" ")                // Naam ko words me baant do
    .map((word) => word[0])    // Har word ka pehla letter lo
    .join("")                  // Sab initials ko jod do
    .toUpperCase();            // Uppercase me convert karo

  const shortName = name.length > 2 ? name.slice(0, 2) : name;
  return shortName;
};

export const getInitialColor = (name) => {
  const letter = name?.[0]?.toUpperCase(); // First letter
  const colorMap = {
    A: "#3498db", // Blue
    B: "#9b59b6", // Purple
    C: "#e67e22", // Orange
    D: "#1abc9c", // Teal
    E: "#f39c12",
    F: "#e74c3c",
    G: "#2ecc71", // Green
    H: "#7f8c8d",
    I: "#16a085",
    J: "#d35400",
    K: "#34495e",
    L: "#c0392b",
    M: "#0cb809ff", // Green
    N: "#2980b9",
    O: "#8e44ad",
    P: "#f1c40f", // Yellow
    Q: "#d35400",
    R: "#2c3e50",
    S: "#c2c605ff", // Yellow
    T: "#45b39d",
    U: "#e74c3c",
    V: "#7d3c98",
    W: "#1abc9c",
    X: "#f1948a",
    Y: "#5dade2",
    Z: "#7fb3d5",
  };

  return colorMap[letter] || "#bdc3c7"; // Default gray if not matched
};

export const getDateWithMonthName = (date) => {
  const splittedDate = date.split("-");
  const newDate = `${splittedDate[2]}, ${months[splittedDate[1] - 1]}  ${splittedDate[0]
    }`;
  return newDate;
};

export const generateTimeSlots = () => {
  const times = [];
  for (let h = 0; h < 24; h++) {
    for (let m = 0; m < 60; m += 15) {
      const hh = String(h).padStart(2, "0");
      const mm = String(m).padStart(2, "0");
      times.push(`${hh}:${mm}:00`);
    }
  }
  return times;
};

export const getRemainingDatesInMonth = (dateArray) => {
  if (!dateArray || dateArray.length === 0) return [];

  // Step 1: Parse year and month from first date in input
  const firstDateParts = dateArray[0].dates.split("-");
  const year = parseInt(firstDateParts[0], 10);
  const month = parseInt(firstDateParts[1], 10); // 1-based

  // Step 2: Total days in that month
  const totalDays = new Date(year, month, 0).getDate(); // Works correctly for May -> 31

  // Step 3: Map of existing dates
  const dateMap = {};
  dateArray.forEach((entry) => {
    dateMap[entry.dates] = entry;
  });

  // Step 4: Final array from 1st to last day
  const result = [];
  for (let day = 1; day <= totalDays; day++) {
    const dd = day.toString().padStart(2, "0");
    const mm = month.toString().padStart(2, "0");
    const formatted = `${year}-${mm}-${dd}`;

    if (dateMap[formatted]) {
      result.push(dateMap[formatted]);
    } else {
      result.push({
        dates: formatted,
        status: "",
        statusCode: "",
        totalHours: "0.00",
      });
    }
  }

  return result;
};

export const isCurrentMonth = (dateStr) => {
  const inputDate = new Date(dateStr);
  const today = new Date();

  return (
    inputDate.getFullYear() === today.getFullYear() &&
    inputDate.getMonth() === today.getMonth()
  );
};

export const getMonth = (input) => {
  const date = new Date(input + "-01"); // Always use day for valid Date

  // Step 2: Month और Year निकालो
  const year = date.getFullYear(); // 2025
  const monthName = date.toLocaleString("default", { month: "long" }); // "May"

  return monthName + ", " + year;
};

export const imageToBase64 = (file) => {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();

    reader.onload = () => {
      resolve({
        name: file.name,
        base64: reader.result,
      });
    };

    reader.onerror = (error) => reject(error);

    reader.readAsDataURL(file);
  });
};

export const convertToBase64 = async (imageUrl) => {
  const response = await fetch(imageUrl, {
    // Include credentials only if needed
    mode: "cors",
    credentials: "include",
  });

  const blob = await response.blob();

  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onloadend = () => resolve(reader.result);
    reader.onerror = reject;
    reader.readAsDataURL(blob);
  });
};

export const getBarChartFormattedData = (input) => {
  // Step 1: Define allowed keys
  const requiredKeys = ["onTime", "lateArrival", "absent"];

  // Step 2: Get datasetLabels dynamically
  const datasetLabels = input
    ? Object.keys(input[0]).filter((key) => requiredKeys.includes(key))
    : [];

  // Step 3: Extract labels (dates)
  const labels = input.map((item) => item.dateValue);

  // Step 4: Prepare separate data arrays
  const dataMap = {};

  datasetLabels.forEach((label) => {
    dataMap[label] = input.map((item) => item[label]);
  });

  // Final result
  const data1 = dataMap["onTime"];
  const data2 = dataMap["lateArrival"];
  const data3 = dataMap["absent"];

  return {
    labels,
    datasetLabels,
    data1,
    data2,
    data3,
  };
};

export const getDoughnutChartFormattedData = (input) => {
  const topFive = input.slice(0, 5);

  const chartLabels = topFive.map(
    (item) => item.designation || "Not Specified"
  ); // No fallback
  const chartValues = topFive.map((item) => item.count);
  const percentage = topFive.map((item) => item.percentage);

  return {
    chartLabels,
    chartValues,
    percentage,
  };
};

export const darkModeStyle = [
  { elementType: "geometry", stylers: [{ color: "#010113" }] },
  { elementType: "labels.icon", stylers: [{ visibility: "off" }] },
  { elementType: "labels.text.fill", stylers: [{ color: "#757575" }] },
  { elementType: "labels.text.stroke", stylers: [{ color: "#212121" }] },
  {
    featureType: "administrative",
    elementType: "geometry",
    stylers: [{ color: "#757575" }],
  },
  {
    featureType: "poi",
    elementType: "labels.text.fill",
    stylers: [{ color: "#757575" }],
  },
  {
    featureType: "road",
    elementType: "geometry",
    stylers: [{ color: "#383838" }],
  },
  {
    featureType: "water",
    elementType: "geometry",
    stylers: [{ color: "#000000" }],
  },
  {
    featureType: "water",
    elementType: "labels.text.fill",
    stylers: [{ color: "#3d3d3d" }],
  },
];

export const notificationTitle = (activeTab, isApprove) => {
  let title = "";
  if (isApprove == "1") {
    title =
      activeTab == 0
        ? "Approve Leave"
        : activeTab == 1
          ? "Approve Regularization"
          : activeTab == 2
            ? "Approve Offset"
            : activeTab == 3
              ? "Approve Permission"
              : "Approve Other";
  } else {
    title =
      activeTab == 0
        ? "Reject Leave"
        : activeTab == 1
          ? "Reject Regularization"
          : activeTab == 2
            ? "Reject Offset"
            : activeTab == 3
              ? "Reject Permission"
              : "Reject Other";
  }
  return title;
};

export const getTitleBtn = (activeTab, isApprove) => {
  let button = {};
  if (isApprove == "1") {
    button.isButton = activeTab == 0 || activeTab == 2 ? true : false;
    button.text = "Approve";
  } else {
    button.isButton = true;
    button.text = "Reject";
  }
  return button;
};

export const getRunPayrollFormattedData = (arr) => {
  const result = arr.map((obj) => {
    const filtered = {};
    for (const [key, value] of Object.entries(obj)) {
      if (
        Array.isArray(value) ||
        (typeof value === "object" && value !== null)
      ) {
        // Skip arrays and non-null objects
        continue;
      }

      if (value === null || value === undefined || value === "") {
        filtered[key] = "-";
      } else {
        filtered[key] = value;
      }
    }
    return filtered;
  });

  return result;
};

// Helper function to build table
export const buildTable = (headers, rows) => {
  const tableRows = [
    new TableRow({
      children: headers.map(
        (header) =>
          new TableCell({
            width: { size: 20, type: WidthType.PERCENTAGE },
            children: [new Paragraph({ text: header, bold: true })],
          })
      ),
    }),
    ...rows.map(
      (row) =>
        new TableRow({
          children: row.map(
            (cell) =>
              new TableCell({
                width: { size: 20, type: WidthType.PERCENTAGE },
                children: [new Paragraph(cell.toString())],
              })
          ),
        })
    ),
  ];

  return new Table({
    rows: tableRows,
    width: { size: 100, type: WidthType.PERCENTAGE },
    borders: {
      top: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
      bottom: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
      left: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
      right: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
      insideHorizontal: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
      insideVertical: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
    },
  });
};

// Helper function to make cell
export const makeCell = (text, bold = false, colSpan = 1) =>
  new TableCell({
    children: [new Paragraph({ children: [new TextRun({ text, bold })] })],
    columnSpan: colSpan,
    width: { size: 1000 * colSpan, type: WidthType.DXA },
  });

export const generateForm22Doc = async (data, format = "docx") => {
  const tableCellStyle = {
    margins: { top: 100, bottom: 100, left: 100, right: 100 },
    borders: {
      top: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
      bottom: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
      left: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
      right: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
    },
  };

  const doc = new Document({
    sections: [
      {
        properties: {},
        children: [
          new Paragraph({
            alignment: AlignmentType.CENTER,
            heading: HeadingLevel.HEADING_1,
            children: [new TextRun({ text: "FORM NO. 22", bold: true })],
          }),

          new Paragraph({
            alignment: AlignmentType.CENTER,
            heading: HeadingLevel.HEADING_1,
            children: [
              new TextRun({
                spacing: { after: 50 },
                text: "Muster Roll cum Register of Wages/Salary/Subsistence Allowance",
                break: 1,
                bold: true,
                thematicBreak: true,
              }),
            ],
          }),

          new Paragraph({
            alignment: AlignmentType.CENTER,
            heading: HeadingLevel.HEADING_2,
            children: [
              new TextRun({
                text: "(See Rule 137)",
                break: 1,
                bold: true,
                size: 20,
              }),
            ],
          }),
          new Paragraph({
            spacing: { after: 50 },
            children: [
              new TextRun({
                text: "I. Form 22 (Muster Roll-cum-Register...) Rule 137 of the Karnataka Factories Rules, 1969",
                size: 22,
                bullet: {
                  level: 0,
                },
              }),
            ],
          }),
          new Paragraph({
            spacing: { after: 50 },
            children: [
              new TextRun({
                text: "II. Form V (Rule 29(1)...) of the Karnataka Minimum Wages Rules, 1958",
                size: 22,
                bullet: {
                  level: 0,
                },
              }),
            ],
          }),
          new Paragraph({
            spacing: { after: 50 },
            children: [
              new TextRun({
                text: "III. Form VII (Rule 29(5)...) of the Karnataka Minimum Wages Rules, 1958",
                size: 22,
                bullet: {
                  level: 0,
                },
              }),
            ],
          }),
          new Paragraph({
            spacing: { after: 50 },
            children: [
              new TextRun({
                text: "IV. Form VII (Rule 5...) of the Karnataka Payment of Wages Rules, 1963",
                size: 22,
                bullet: {
                  level: 0,
                },
              }),
            ],
          }),
          new Paragraph({
            spacing: { after: 50 },
            children: [
              new TextRun({
                text: "V. Form XVI (Rule 78(1)(a)(i)...) Contract Labour (Regulation & Abolition) Rules, 1974",
                size: 22,
                bullet: {
                  level: 0,
                },
              }),
            ],
          }),
          new Paragraph({
            spacing: { after: 200 },
            children: [
              new TextRun({
                text: "VI. Form XVII (Rule 78(1)(a)(ii)...) Contract Labour (Regulation & Abolition) Rules, 1974",
                size: 22,
                bullet: {
                  level: 0,
                },
              }),
            ],
          }),

          // Table for Name and Address headers
          new Table({
            width: { size: 100, type: WidthType.PERCENTAGE },
            rows: [
              new TableRow({
                children: [
                  new TableCell({
                    ...tableCellStyle,
                    children: [
                      new Paragraph(
                        "Name and Address of the Factory/Establishment"
                      ),
                    ],
                  }),
                  new TableCell({
                    ...tableCellStyle,
                    children: [
                      new Paragraph(
                        "Name and Address of the Contractor (if any)"
                      ),
                    ],
                  }),
                  new TableCell({
                    ...tableCellStyle,
                    children: [
                      new Paragraph(
                        "Name and Address of the Principal Employer"
                      ),
                    ],
                  }),
                ],
              }),
            ],
          }),

          new Paragraph({
            spacing: { before: 200, after: 200 },
            children: [
              new TextRun("Place of Work: _________________     "),
              new TextRun("Month / Year: ________________"),
            ],
          }),

          // Table for employee data
          new Table({
            width: { size: 100, type: WidthType.PERCENTAGE },
            rows: [
              new TableRow({
                children: [
                  "SL No",
                  "Name of Employee",
                  "Emp No",
                  "Dept",
                  "Days Worked",
                  "Wages",
                ].map(
                  (text) =>
                    new TableCell({
                      ...tableCellStyle,
                      children: [new Paragraph({ text, bold: true })],
                    })
                ),
              }),
              new TableRow({
                children: [
                  "1",
                  "Amit Sharma",
                  "EMP001",
                  "Accounts",
                  "26",
                  "₹ 24,000",
                ].map(
                  (text) =>
                    new TableCell({
                      ...tableCellStyle,
                      children: [new Paragraph(text)],
                    })
                ),
              }),
            ],
          }),

          new Paragraph({
            spacing: { before: 500 },
            alignment: AlignmentType.CENTER,
            children: [
              new TextRun({
                text: "Signature of the Occupier/Principal Employer/Authorized Signatory",
                italics: true,
              }),
            ],
          }),
        ],
      },
    ],
  });

  Packer.toBlob(doc).then((blob) => {
    saveAs(blob, "Form_22.docx");
  });
};

export const downloadAsPdf = async (fileData) => { };

export const exportToExcel = (data, page, name) => {
  const finalData =
    page == "run-payroll" ? getRunPayrollFormattedData(data) : data;
  if (!finalData.length) return;

  const modifiedData = finalData.map((item, index) => ({
    "S.No": index + 1,
    ...item,
  }));

  const worksheet = XLSX.utils.json_to_sheet(modifiedData, { origin: "A2" });

  // ✅ 1. Apply styled headers
  const headers = Object.keys(modifiedData[0]);
  headers.forEach((header, idx) => {
    const cellRef = XLSX.utils.encode_cell({ r: 1, c: idx });
    worksheet[cellRef] = {
      v: header,
      t: "s",
      s: {
        fill: { fgColor: { rgb: "D9E1F2" } },
        font: { bold: true, color: { rgb: "000000" } },
        alignment: { horizontal: "center" },
        border: {
          top: { style: "thin", color: { rgb: "000000" } },
          bottom: { style: "thin", color: { rgb: "000000" } },
          left: { style: "thin", color: { rgb: "000000" } },
          right: { style: "thin", color: { rgb: "000000" } },
        },
      },
    };
  });

  // ✅ 2. Auto-adjust column widths
  const columnWidths = headers.map((header) => {
    const maxContentLength = Math.max(
      header.length,
      ...modifiedData.map((row) =>
        row[header] ? row[header].toString().length : 0
      )
    );
    return { wch: maxContentLength + 2 }; // extra padding
  });
  worksheet["!cols"] = columnWidths;

  // ✅ 3. Finalize and export
  const workbook = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(workbook, worksheet, "Sheet1");

  const buffer = XLSX.write(workbook, { bookType: "xlsx", type: "array" });
  const blob = new Blob([buffer], {
    type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
  });

  saveAs(blob, `${name}.xlsx`);
};

// const exportToExcel = (data, page) => {
//   const finalData =
//     page == "run-payroll" ? getRunPayrollFormattedData(data) : data;
//   if (!finalData.length) return;

//   // ✅ Add dynamic S.No to each row
//   const modifiedData = finalData.map((item, index) => ({
//     "S.No": index + 1,
//     ...item,
//   }));

//   const worksheet = XLSX.utils.json_to_sheet(modifiedData, { origin: "A2" });

//   // Custom headers with styles
//   const headers = Object.keys(modifiedData[0]);
//   headers.forEach((header, idx) => {
//     const cellRef = XLSX.utils.encode_cell({ r: 1, c: idx });
//     worksheet[cellRef] = {
//       v: header,
//       t: "s",
//       s: {
//         fill: { fgColor: { rgb: "D9E1F2" } }, // Light Blue
//         font: { bold: true, color: { rgb: "000000" } },
//         alignment: { horizontal: "center" },
//         border: {
//           top: { style: "thin", color: { rgb: "000000" } },
//           bottom: { style: "thin", color: { rgb: "000000" } },
//           left: { style: "thin", color: { rgb: "000000" } },
//           right: { style: "thin", color: { rgb: "000000" } },
//         },
//       },
//     };
//   });

//   const workbook = XLSX.utils.book_new();
//   XLSX.utils.book_append_sheet(workbook, worksheet, "Sheet1");

//   const buffer = XLSX.write(workbook, { bookType: "xlsx", type: "array" });
//   const blob = new Blob([buffer], {
//     type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
//   });

//   saveAs(blob, "Final_Styled_Excel.xlsx");
// };

export const exportToTrackerExcel = (data, formDownloadDate) => {
  if (!data || data.length === 0) return;

  const originalHeaders = Object.keys(data[0]);
  const formattedHeaders = originalHeaders.map(formatHeader);
  const finalHeaders = ["S. No.", ...formattedHeaders];

  const rows = data.map((item, index) => {
    const rowData = originalHeaders.map((key) => {
      const val = item[key];
      return val === null || val === undefined || val === "" ? "-" : val;
    });
    return [index + 1, ...rowData];
  });

  const sheetData = [finalHeaders, ...rows];

  // Create worksheet
  const ws = XLSX.utils.aoa_to_sheet(sheetData);

  // Apply styling
  const headerCellStyle = {
    font: { bold: true, color: { rgb: "000000" } },
    alignment: { horizontal: "center", vertical: "center" },
    fill: { fgColor: { rgb: "D9E1F2" } }, // Light Blue
    border: {
      top: { style: "thin", color: { rgb: "000000" } },
      bottom: { style: "thin", color: { rgb: "000000" } },
      left: { style: "thin", color: { rgb: "000000" } },
      right: { style: "thin", color: { rgb: "000000" } },
    },
  };

  const normalCellStyle = {
    font: { color: { rgb: "000000" } },
    alignment: { horizontal: "left", vertical: "center", wrapText: true },
    border: {
      top: { style: "thin", color: { rgb: "000000" } },
      bottom: { style: "thin", color: { rgb: "000000" } },
      left: { style: "thin", color: { rgb: "000000" } },
      right: { style: "thin", color: { rgb: "000000" } },
    },
  };

  // Apply styles
  sheetData.forEach((row, rowIndex) => {
    row.forEach((_, colIndex) => {
      const cellRef = XLSX.utils.encode_cell({ r: rowIndex, c: colIndex });
      if (!ws[cellRef]) return;
      ws[cellRef].s = rowIndex === 0 ? headerCellStyle : normalCellStyle;
    });
  });

  // Auto width for columns
  ws["!cols"] = sheetData[0].map((_, colIndex) => {
    const maxLen = sheetData.reduce((acc, row) => {
      const cell = row[colIndex];
      return Math.max(acc, cell?.toString().length || 0);
    }, 10);
    return { width: maxLen + 2 };
  });

  // Fix header row height only (optional)
  ws["!rows"] = [{ hpt: 25 }];

  const wb = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(wb, ws, "Sheet1");

  const wbBlob = XLSX.write(wb, { bookType: "xlsx", type: "binary" });
  const buf = new ArrayBuffer(wbBlob.length);
  const view = new Uint8Array(buf);
  for (let i = 0; i < wbBlob.length; i++) {
    view[i] = wbBlob.charCodeAt(i) & 0xff;
  }

  saveAs(
    new Blob([buf], { type: "application/octet-stream" }),
    `Attendance_Tracker_Report_${formDownloadDate}.xlsx`
  );
};

// const exportToTrackerExcel = (data) => {
//   if (!data || data.length === 0) return;

//   // Extract headers from first object keys
//   const originalHeaders = Object.keys(data[0]);
//   const headers = ["S. No.", ...originalHeaders];

//   // Prepare rows with serial number
//   const sheetData = [
//     headers,
//     ...data.map((obj, index) => [
//       index + 1, // Serial Number
//       ...originalHeaders.map((header) => obj[header]),
//     ]),
//   ];

//   // Prepare styles
//   const headerStyle = {
//     font: { bold: true },
//     alignment: { horizontal: "center", vertical: "center", wrapText: true },
//     fill: { fgColor: { rgb: "FFD966" } },
//     border: {
//       top: { style: "thin", color: { rgb: "000000" } },
//       bottom: { style: "thin", color: { rgb: "000000" } },
//       left: { style: "thin", color: { rgb: "000000" } },
//       right: { style: "thin", color: { rgb: "000000" } },
//     },
//   };

//   const cellStyle = {
//     alignment: { horizontal: "center", vertical: "center", wrapText: true },
//     border: {
//       top: { style: "thin", color: { rgb: "000000" } },
//       bottom: { style: "thin", color: { rgb: "000000" } },
//       left: { style: "thin", color: { rgb: "000000" } },
//       right: { style: "thin", color: { rgb: "000000" } },
//     },
//   };

//   // Create worksheet with styles
//   const worksheet = XLSX.utils.aoa_to_sheet(sheetData);

//   // Apply header style
//   headers.forEach((_, colIdx) => {
//     const cellRef = XLSX.utils.encode_cell({ c: colIdx, r: 0 });
//     if (worksheet[cellRef]) worksheet[cellRef].s = headerStyle;
//   });

//   // Apply cell styles to data
//   data.forEach((_, rowIdx) => {
//     headers.forEach((_, colIdx) => {
//       const cellRef = XLSX.utils.encode_cell({ c: colIdx, r: rowIdx + 1 });
//       if (worksheet[cellRef]) worksheet[cellRef].s = cellStyle;
//     });
//   });

//   const workbook = {
//     Sheets: { Attendance: worksheet },
//     SheetNames: ["Attendance"],
//   };

//   XLSX.writeFileXLSX(workbook, "Attendance_Tracker_Report.xlsx");
// };

export const downloadPdf = async (file, fileName) => {
  const blob = await pdf(file).toBlob();
  saveAs(blob, `${fileName}.pdf`);
};

export function getMaxByKey(dataArray, keyName) {
  let maxObject = {};

  for (let obj of dataArray) {
    const currentList = obj[keyName];

    if (
      Array.isArray(currentList) &&
      currentList.length > (maxObject[keyName]?.length || 0)
    ) {
      maxObject = obj;
    }
  }

  return maxObject;
}

export const extractMaxAllowanceListObject = (dataArray) => {
  if (!Array.isArray(dataArray) || dataArray.length === 0) {
    return { allowanceList: {} };
  }

  // Step 1: Find object with max allowanceList.length
  let maxObject = dataArray[0];

  for (let obj of dataArray) {
    if (
      Array.isArray(obj.allowanceList) &&
      obj.allowanceList.length > (maxObject.allowanceList?.length || 0)
    ) {
      maxObject = obj;
    }
  }

  // Step 2: Convert that allowanceList to desired object format
  const resultObj = {};

  for (let item of maxObject.allowanceList || []) {
    if (item.name && item.monthlyAmount !== undefined) {
      resultObj[item.name] = item.monthlyAmount;
    }
  }

  return { allowanceList: resultObj };
};

export const formattedRunPayrollSalarySlip = (data) => {
  const dd = extractMaxAllowanceListObject(data);
  
  // DEBUG: Log what data we're getting
  console.log("=== DEBUG: Data received for salary slip ===");
  console.log("Total records:", data.length);
  if (data.length > 0) {
    console.log("First record structure:", data[0]);
    console.log("Keys in first record:", Object.keys(data[0]));
    
    // Check for date-related fields
    const dateFields = Object.keys(data[0]).filter(key => 
      key.toLowerCase().includes('date') || 
      key.toLowerCase().includes('cycle') ||
      key.toLowerCase().includes('range')
    );
    console.log("Date-related fields found:", dateFields);
    
    // Log specific fields you're checking
    console.log("attendanceCycle:", data[0].attendanceCycle);
    console.log("payrollModelName:", data[0].payrollModelName);
    console.log("salaryCountDays:", data[0].salaryCountDays);
    
    if (data[0].salaryCountDays) {
      console.log("salaryCountDays keys:", Object.keys(data[0].salaryCountDays));
      console.log("cycleStartDate:", data[0].salaryCountDays.cycleStartDate);
      console.log("cycleEndDate:", data[0].salaryCountDays.cycleEndDate);
      console.log("cycleTypeValue:", data[0].salaryCountDays.cycleTypeValue);
    }
  }

  const formattedData = data.map((item) => {
    // Function to extract attendance cycle from multiple possible locations
    const extractAttendanceCycle = (item) => {
      let cycleDisplay = "-";
      let cycleType = "-";
      let dateRange = "-";
      
      console.log(`=== Processing employee ${item.employeeId || item.staffName} ===`);
      
      // Method 1: Check attendanceCycle field directly
      if (item.attendanceCycle) {
        console.log("Method 1 - attendanceCycle found:", item.attendanceCycle);
        if (item.attendanceCycle.includes('|')) {
          const parts = item.attendanceCycle.split('|');
          if (parts.length >= 2) {
            cycleType = parts[0];
            dateRange = parts[1];
            console.log(`Extracted - cycleType: ${cycleType}, dateRange: ${dateRange}`);
          }
        } else {
          cycleType = item.attendanceCycle;
          console.log(`Single value - cycleType: ${cycleType}`);
        }
      }
      
      // Method 2: Check if payrollModelName contains cycle info
      if (cycleType === "-" && item.payrollModelName && item.payrollModelName.includes('|')) {
        console.log("Method 2 - payrollModelName with pipe found:", item.payrollModelName);
        const parts = item.payrollModelName.split('|');
        if (parts.length >= 3) {
          // Format: "Model Name | CycleType | DateRange"
          cycleType = parts[1].trim();
          dateRange = parts[2].trim();
          console.log(`Extracted - cycleType: ${cycleType}, dateRange: ${dateRange}`);
        }
      }
      
      // Method 3: Check salaryCountDays for cycle information
      if (item.salaryCountDays) {
        console.log("Method 3 - salaryCountDays found:", item.salaryCountDays);
        
        if (item.salaryCountDays.cycleTypeValue) {
          cycleType = item.salaryCountDays.cycleTypeValue;
          console.log(`From salaryCountDays - cycleTypeValue: ${cycleType}`);
        }
        
        // Check for dates in salaryCountDays
        if (item.salaryCountDays.cycleStartDate && item.salaryCountDays.cycleEndDate) {
          console.log("Found cycle dates:", item.salaryCountDays.cycleStartDate, item.salaryCountDays.cycleEndDate);
          try {
            const startDate = new Date(item.salaryCountDays.cycleStartDate);
            const endDate = new Date(item.salaryCountDays.cycleEndDate);
            
            if (!isNaN(startDate.getTime()) && !isNaN(endDate.getTime())) {
              const startDay = String(startDate.getDate()).padStart(2, '0');
              const endDay = String(endDate.getDate()).padStart(2, '0');
              const startMonth = String(startDate.getMonth() + 1).padStart(2, '0');
              const endMonth = String(endDate.getMonth() + 1).padStart(2, '0');
              
              // Check if same month
              if (startMonth === endMonth) {
                dateRange = `${startDay}-${endDay}`;
              } else {
                // Different months: include month in display
                dateRange = `${startDay}/${startMonth}-${endDay}/${endMonth}`;
              }
              console.log(`Formatted dateRange: ${dateRange}`);
            }
          } catch (e) {
            console.error("Error parsing dates:", e);
          }
        }
      }
      
      // Method 4: Check for other date fields
      if (dateRange === "-") {
        console.log("Method 4 - Checking for other date fields");
        // Check for fields like startDate, endDate, etc.
        if (item.startDate && item.endDate) {
          try {
            const startDate = new Date(item.startDate);
            const endDate = new Date(item.endDate);
            
            if (!isNaN(startDate.getTime()) && !isNaN(endDate.getTime())) {
              const startDay = String(startDate.getDate()).padStart(2, '0');
              const endDay = String(endDate.getDate()).padStart(2, '0');
              dateRange = `${startDay}-${endDay}`;
              console.log(`From startDate/endDate: ${dateRange}`);
            }
          } catch (e) {
            console.error("Error parsing startDate/endDate:", e);
          }
        }
      }
      
      // Method 5: Check for periodStart and periodEnd
      if (dateRange === "-" && item.salaryCountDays) {
        if (item.salaryCountDays.periodStart && item.salaryCountDays.periodEnd) {
          console.log("Found periodStart/periodEnd:", item.salaryCountDays.periodStart, item.salaryCountDays.periodEnd);
          try {
            const startDate = new Date(item.salaryCountDays.periodStart);
            const endDate = new Date(item.salaryCountDays.periodEnd);
            
            if (!isNaN(startDate.getTime()) && !isNaN(endDate.getTime())) {
              const startDay = String(startDate.getDate()).padStart(2, '0');
              const endDay = String(endDate.getDate()).padStart(2, '0');
              dateRange = `${startDay}-${endDay}`;
              console.log(`From periodStart/periodEnd: ${dateRange}`);
            }
          } catch (e) {
            console.error("Error parsing period dates:", e);
          }
        }
      }
      
      // Format cycle type for better readability
      if (cycleType !== "-") {
        const cycleTypeLower = cycleType.toLowerCase();
        if (cycleTypeLower.includes("calendar") || cycleTypeLower.includes("month")) {
          cycleType = "Calendar Month";
        } else if (cycleTypeLower.includes("fixed")) {
          cycleType = "Fixed Date";
        } else if (cycleTypeLower.includes("custom")) {
          cycleType = "Custom Date";
        } else if (cycleTypeLower.includes("financial")) {
          cycleType = "Financial Year";
        } else if (cycleTypeLower.includes("weekly")) {
          cycleType = "Weekly";
        } else if (cycleTypeLower.includes("bi")) {
          cycleType = "Bi-Weekly";
        }
        console.log(`Formatted cycleType: ${cycleType}`);
      }
      
      // Format date range to ensure 2 digits
      if (dateRange !== "-" && dateRange.includes('-')) {
        const parts = dateRange.split('-');
        if (parts.length === 2) {
          // Handle formats like "1-31" or "01/01-31/01"
          const startPart = parts[0];
          const endPart = parts[1];
          
          // If simple day numbers (no slashes)
          if (!startPart.includes('/') && !endPart.includes('/')) {
            const formattedStart = startPart.padStart(2, '0');
            const formattedEnd = endPart.padStart(2, '0');
            dateRange = `${formattedStart}-${formattedEnd}`;
          }
        }
        console.log(`Final dateRange: ${dateRange}`);
      }
      
      // Create display text
      if (cycleType !== "-" && dateRange !== "-") {
        cycleDisplay = `${cycleType} (${dateRange})`;
      } else if (cycleType !== "-") {
        cycleDisplay = cycleType;
      } else if (dateRange !== "-") {
        cycleDisplay = dateRange;
      }
      
      console.log(`Final result - display: "${cycleDisplay}", type: "${cycleType}", dateRange: "${dateRange}"`);
      console.log("=== End processing ===\n");
      
      return {
        display: cycleDisplay,
        type: cycleType,
        dateRange: dateRange
      };
    };
    
    const attendanceCycleInfo = extractAttendanceCycle(item);
    
    return {
      "EMP Code": item.employeeId ? item.employeeId : "-",
      "Candidate Name": item.staffName ? item.staffName : "-",
      "Attendance Cycle": attendanceCycleInfo.display,
      "Date Range": attendanceCycleInfo.dateRange,
      "Payroll Model": item.payrollModelName || "-",
      DOJ: item.dateOfJoin ? item.dateOfJoin : "-",
      DOL: item.dateOfLeaving ? item.dateOfLeaving : "-",
      "Account Number": item.accountNumber ? item.accountNumber : "-",
      Designation: item.jobTitle ? item.jobTitle : "-",
      // ... rest of your fields (keep as is)
    };
  });
  
  return formattedData;
};

export const convertMonthlyAttendanceInObject = (data) => {
  // Step 1: Extract monthlyAttendance and format it
  const monthlyAttendanceObj = {};
  data.monthlyAttendance.forEach(({ date, status }) => {
    const formattedKey = formatDate(date);
    const statusKey = status.toLowerCase().trim() || "";
    monthlyAttendanceObj[formattedKey] = statusMap[statusKey];
  });

  // Step 2: Flatten the object excluding attendanceSummary & monthlyAttendance
  // const {
  //   attendanceSummary, // skip
  //   monthlyAttendance, // skip
  //   ...flatData
  // } = data;

  const attSummary = {
    WO: data.attendanceSummary.WeekOff ? data.attendanceSummary.WeekOff : "-",
    Present: data.attendanceSummary.Present
      ? data.attendanceSummary.Present
      : "-",
    "Sick Leave": data.attendanceSummary["Sick Leave"]
      ? data.attendanceSummary["Sick Leave"]
      : "-",
    "Privileged Leave": data.attendanceSummary["Privileged Leave"]
      ? data.attendanceSummary["Privileged Leave"]
      : "-",
    "Paid Leave": data.attendanceSummary["Paid Leave"]
      ? data.attendanceSummary["Paid Leave"]
      : "-",
    "Half Day": data.attendanceSummary["Half Day"]
      ? data.attendanceSummary["Half Day"]
      : "-",
    "National Holiday": data.attendanceSummary.Holiday
      ? data.attendanceSummary.Holiday
      : "-",
    "Total Payable Days": data.totalPayableDays ? data.totalPayableDays : "-",
    Absent: data.attendanceSummary.Absent ? data.attendanceSummary.Absent : "-",
    "Not Joined": data.attendanceSummary["Not Set"]
      ? data.attendanceSummary["Not Set"]
      : "-",
  };

  const mainData = {
    employeeId: data.employeeId,
    staffName: data.staffName,
    designation: data.jobTitle,
    dateOfJoin: data.dateOfJoin,
    ...monthlyAttendanceObj,
    ...attSummary,
    Inactive: data.status == "1" ? "Active" : "InActive",
  };

  /*
  "Un Paid Leave": attendanceSummary.Present,
    "Late CheckIn": attendanceSummary.Present,
    "Early CheckOut": attendanceSummary.Present,
    "Overtime": attendanceSummary.Present,
    "WeekOff": attendanceSummary.Present,
    "Holiday": attendanceSummary.Present,
    "Auto Clocked Out": attendanceSummary.Present,
    "LateCheckIn EarlyCheckOut": attendanceSummary.Present
*/

  // Step 3: Merge main data + attendance object
  // const finalRow = {
  //   ...flatData,
  //   ...monthlyAttendanceObj,
  //   ...attSummary,
  // };

  return mainData;
};

export const trackerDataFormat = (data) => {
  const mainArray = data.map((item) => {
    return convertMonthlyAttendanceInObject(item);
  });
  return mainArray;
};

// Monthly Attendance Form 22 Excel generate Functions are here

export const getMonthlyAttendanceInExcelFormat = (array) => {
  const newArray = array.map((item) => {
    let bp = item.salaryBreakup?.data?.salaryOutput?.basicPay || 0;
    let hr = item.salaryBreakup?.data?.salaryOutput?.hraPay || 0;
    let ba = item.salaryBreakup?.data?.salaryOutput?.bonusAmount || 0;

    let PF = item.salaryBreakup?.data?.salaryOutput?.employeePf || 0;
    let PT = item.salaryBreakup?.data?.salaryOutput?.professionalTax || 0;
    let ESI = item.salaryBreakup?.data?.salaryOutput?.employeeEsi || 0;

    return {
      "Emp. ID": item.employeeId ? item.employeeId : "-",
      "Name Of The Employee": item.staffName ? item.staffName : "-",
      "Father / Husband Name": item.fatherName ? item.fatherName : "-",
      "Male / Female": item.gender ? item.gender : "-",
      "Designation/Department": item.designation ? item.designation : "-",
      "Date of Joining": item.dateOfJoin ? item.dateOfJoin : "-",
      "ESI No.": item.esiNo ? item.esiNo : "-",
      "UAN No.": item.uanNumber ? item.uanNumber : "-",
      "Wages Fixed including VDA": item.salaryBreakup?.data?.salaryOutput
        ?.grossSalary
        ? item.salaryBreakup?.data?.salaryOutput?.grossSalary
        : "-",
      ...convertDateArrayInObject(item.monthlyAttendance),
      "Date of Suspention if any": item.suspentionDate
        ? item.suspentionDate
        : "-",
      "No. of Payable Days": item.totalPayableDays
        ? item.totalPayableDays
        : "-",
      "Total OT Hours Worked": item.otHours ? item.otHours : "-",
      BASIC: item.salaryBreakup?.data?.salaryOutput?.basicPay
        ? item.salaryBreakup?.data?.salaryOutput?.basicPay
        : "-",
      HRA: item.salaryBreakup?.data?.salaryOutput?.hraPay
        ? item.salaryBreakup?.data?.salaryOutput?.hraPay
        : "-",
      TRANSPORT: item.transport ? item.transport : "-",
      "OTH. ALLOW": item.otherAllow ? item.otherAllow : "-",
      BONUS: item.salaryBreakup?.data?.salaryOutput?.bonusAmount
        ? item.salaryBreakup?.data?.salaryOutput?.bonusAmount
        : "-",
      "NS ALLOW": item.nsAllow ? item.nsAllow : "-",
      "LEAVE PAY": item.leavePay ? item.leavePay : "-",
      VDA: item.vda ? item.vda : "-",
      "Gross Total": parseFloat(bp) + parseFloat(hr) + parseFloat(ba),
      PF: item.salaryBreakup?.data?.salaryOutput?.employeePf
        ? item.salaryBreakup?.data?.salaryOutput?.employeePf
        : "-",
      PT: item.salaryBreakup?.data?.salaryOutput?.professionalTax
        ? item.salaryBreakup?.data?.salaryOutput?.professionalTax
        : "-",
      ESI: item.salaryBreakup?.data?.salaryOutput?.employeeEsi
        ? item.salaryBreakup?.data?.salaryOutput?.employeeEsi
        : "-",
      "OTHER DED": item.otherDed ? item.otherDed : "-",
      "TRANS DED": item.tranceDed ? item.tranceDed : "-",
      INSURANCE: item.insurance ? item.insurance : "-",
      "Total Deduction": parseFloat(PF) + parseFloat(PT) + parseFloat(ESI),
      "Net Payable": item.salaryBreakup?.data?.salaryOutput?.netSalary
        ? item.salaryBreakup?.data?.salaryOutput?.netSalary
        : "-",
      "Mode of Payment Cash/Cheque No.": item.paymentMode
        ? item.paymentMode
        : "-",
      "Employee Signature/Thumb Impression": item.signature
        ? item.signature
        : "-",
    };
  });
  return newArray;
};

export const generateHeaders = (employeeData, attendanceDays) => {
  if (!employeeData || employeeData.length === 0) return [];

  const sample = employeeData[0];

  const fixedHeaders = Object.keys(sample).filter(
    (key) => key !== "attendance"
  );

  const dynamicAttendanceHeaders = attendanceDays.map((d) => `Day ${d}`);

  return [
    ...fixedHeaders.slice(0, 8),
    ...dynamicAttendanceHeaders,
    ...fixedHeaders.slice(8),
  ];
};

export const statusMap = {
  present: "P",
  absent: "A",
  weekoff: "WO",
  "week off": "WO",
  holiday: "H",
  "sick leave": "SL",
  sickleave: "SL",
  "priviledge leave": "PL",
  priviledgeleave: "PL",
  "national holiday": "NH",
  "casual leave": "CL",
  casualleave: "CL",
  "earned leave": "EL",
  earnedleave: "EL",
};

export const convertDateArrayInObject = (attendanceArray) => {
  const allDates = new Set(attendanceArray.map((d) => d.date));

  // Find min and max dates from attendanceArray
  const dateList = attendanceArray.map((item) => new Date(item.date));
  const minDate = new Date(Math.min(...dateList));
  const maxDate = new Date(Math.max(...dateList));

  const result = {};

  for (let d = new Date(minDate); d <= maxDate; d.setDate(d.getDate() + 1)) {
    const dateStr = d.toISOString().split("T")[0]; // Format: yyyy-mm-dd
    const key = formatDate(dateStr); // Format: Aug-6

    const dayData = attendanceArray.find((item) => item.date === dateStr);
    // if (dayData) {
    const statusKey = dayData.status?.toLowerCase().trim() || "";
    result[key] = statusMap[statusKey] || "-";
    // } else {
    //   result[key] = "-"; // Missing date
    // }
  }

  return result;
};

export const downloadForm22Excel = (data, initDateArray, dateName, saveFileAs) => {
  if (!data || !data.employeeData || data.employeeData.length === 0) return;

  const employeeData = data.employeeData;

  const attendancePlace =
    initDateArray.length < 3
      ? 10
      : initDateArray.length <= 7 && initDateArray.length > 3
        ? 12
        : initDateArray.length >= 7 && initDateArray.length < 14
          ? 14
          : initDateArray.length >= 14 && initDateArray.length <= 21
            ? 20
            : 25;

  const type =
    saveFileAs == "xlsx"
      ? "application/octet-stream"
      : "text/csv;charset=utf-8;";

  // ✅ Preserve the key order from first object
  const originalHeaders = [];
  const seen = new Set();
  employeeData.forEach((emp) => {
    Object.keys(emp).forEach((key) => {
      if (!seen.has(key)) {
        seen.add(key);
        originalHeaders.push(key);
      }
    });
  });

  const finalHeaders = ["S. No.", ...originalHeaders];

  const rows = employeeData.map((item, index) => {
    const rowData = originalHeaders.map((key) => {
      const val = item[key];
      return val === null || val === undefined || val === "" ? "-" : val;
    });
    return [index + 1, ...rowData];
  });

  const ws = {};

  const setCell = (r, c, value, style = {}) => {
    const cellRef = XLSX.utils.encode_cell({ r, c });
    ws[cellRef] = { v: value, t: "s", s: style };
  };

  const staticTitleStyle = {
    font: { bold: true, color: { rgb: "000000" }, sz: 20 },
    alignment: { horizontal: "left", vertical: "center" },
  };

  const staticTitleOneStyle = {
    font: { bold: true, color: { rgb: "000000" }, sz: 16 },
    alignment: { horizontal: "left", vertical: "center" },
  };

  const staticSubTitleStyle = {
    font: { bold: true, color: { rgb: "000000" } },
    alignment: { horizontal: "left", vertical: "center" },
  };

  const headerCellStyle = {
    font: { bold: true, color: { rgb: "000000" } },
    alignment: { horizontal: "center", vertical: "center" },
    fill: { fgColor: { rgb: "D9E1F2" } },
    border: {
      top: { style: "thin", color: { rgb: "000000" } },
      bottom: { style: "thin", color: { rgb: "000000" } },
      left: { style: "thin", color: { rgb: "000000" } },
      right: { style: "thin", color: { rgb: "000000" } },
    },
  };

  const normalCellStyle = {
    font: { color: { rgb: "000000" } },
    alignment: { horizontal: "left", vertical: "center", wrapText: true },
    border: {
      top: { style: "thin", color: { rgb: "000000" } },
      bottom: { style: "thin", color: { rgb: "000000" } },
      left: { style: "thin", color: { rgb: "000000" } },
      right: { style: "thin", color: { rgb: "000000" } },
    },
  };

  const centerCellStyle = {
    font: { color: { rgb: "000000" } },
    alignment: { horizontal: "center", vertical: "center", wrapText: true },
    border: {
      top: { style: "thin", color: { rgb: "000000" } },
      bottom: { style: "thin", color: { rgb: "000000" } },
      left: { style: "thin", color: { rgb: "000000" } },
      right: { style: "thin", color: { rgb: "000000" } },
    },
  };


  // Title Info
  setCell(0, 19, "Form - 22", staticTitleStyle);
  setCell(
    1,
    18,
    "COMBINED MUSTER ROLL CUM REGISTER OF WAGES",
    staticTitleOneStyle
  );

  setCell(3, 0, "Name & Address of the Contractor:", staticSubTitleStyle);
  setCell(3, 3, data.contractorName);
  setCell(4, 3, data.contractorAddress);

  setCell(3, 12, "Name & Address of the Establishment:", staticSubTitleStyle);
  setCell(3, 15, data.establishmentName);
  setCell(4, 15, data.establishmentAddress);

  setCell(
    3,
    25,
    "Name & Address of the Principal Employer :",
    staticSubTitleStyle
  );
  setCell(3, 29, data.principalEmployerName);
  setCell(4, 29, data.principalEmployerAddress);

  setCell(7, 0, "Nature and Location of Work:", staticSubTitleStyle);
  setCell(7, 3, data.natureOfWork);
  setCell(8, 3, data.locationOfWork);

  setCell(7, 14, "Wages Period:", staticSubTitleStyle);
  setCell(7, 15, data.wagesPeriod);



  const startRowIndex = 13;

  // Header Row
  finalHeaders.forEach((header, colIndex) => {
    setCell(startRowIndex, colIndex, header, headerCellStyle);
  });

  const staticRow = [];

  // Part 1: 1 to 10
  for (let i = 1; i <= 10; i++) {
    staticRow.push(i);
  }

  // Part 2: middle section (only 11 in the center)
  const totalDates = initDateArray.length; // e.g., 13
  const part2Start = staticRow.length; // current length = 10
  const part2End = part2Start + totalDates; // dynamic end

  // Find middle index for Part 2
  const middleIndex = Math.floor((part2Start + part2End - 1) / 2);

  setCell(11, middleIndex, "Attendance", staticSubTitleStyle);
  // setCell(11, 40, "Apr 2025 - May 2025");

  setCell(
    12,
    middleIndex + 13,
    "Earned Wage and other Allowances",
    staticSubTitleStyle
  );
  setCell(12, middleIndex + 22, "Deductions", staticSubTitleStyle);

  for (let i = part2Start; i < part2End; i++) {
    if (i === middleIndex) {
      staticRow.push(11);
    } else {
      staticRow.push("");
    }
  }

  const data3 = [
    12, 12, 13, 13, 14, 15, 15, 16, 16, 16, 16, 17, 18, 19, 20, 21, 21, 21, 21,
    22, 23, 24,
  ];

  for (let i = 0; i < data3.length; i++) {
    staticRow.push(data3[i]);
  }

  // Static Data Rows
  staticRow.forEach((val, colIndex) => {
    setCell(startRowIndex + 1, colIndex, val, centerCellStyle);
  });

  // Data Rows
  rows.forEach((row, rowIndex) => {
    row.forEach((val, colIndex) => {
      setCell(startRowIndex + 2 + rowIndex, colIndex, val, normalCellStyle);
    });
  });

  // Auto column widths
  const allRows = [finalHeaders, ...rows];
  ws["!cols"] = finalHeaders.map((_, colIndex) => {
    const maxLen = allRows.reduce((acc, row) => {
      const val = row[colIndex];
      return Math.max(acc, val?.toString().length || 0);
    }, 10);
    return { width: maxLen + 2 };
  });

  // Optional row height
  ws["!rows"] = [{ hpt: 25 }];

  // Define sheet range
  const totalRows = startRowIndex + 1 + rows.length;
  const totalCols = finalHeaders.length;
  ws["!ref"] = XLSX.utils.encode_range({
    s: { r: 0, c: 0 },
    e: { r: totalRows, c: totalCols },
  });

  // Create and download workbook
  const wb = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(wb, ws, "Form 22");

  const wbout = XLSX.write(wb, { bookType: saveFileAs, type: "array" });
  // const wbout = XLSX.write(wb, { bookType: saveFileAs, type: "binary" });
  // const buf = new ArrayBuffer(wbout.length);
  // const view = new Uint8Array(buf);
  // for (let i = 0; i < wbout.length; i++) {
  //   view[i] = wbout.charCodeAt(i) & 0xff;
  // }

  saveAs(
    new Blob([wbout], { type: type }),
    `Form_22_Report_${dateName}.${saveFileAs}`
  );
  // saveAs(new Blob([buf], { type: type }), `Form_22_Report_${dateName}.${saveFileAs}`);
};

export const totalAmountOfAllowance = (allowanceList) => {
  if (!allowanceList && allowanceList.length == 0) {
    return 0;
  }
  const totalMonthlyAmount = allowanceList.reduce((sum, item) => {
    return sum + parseFloat(item.monthlyAmount);
  }, 0);
  return totalMonthlyAmount;
};

export const updateUserData = (newData, replace = false) => {
  // Local storage se object nikalo
  const storedData = JSON.parse(localStorage.getItem("user_data")) || {};

  // Agar replace true hai to pura object replace kar do
  const updatedData = replace ? newData : { ...storedData, ...newData };

  // Local storage update karo
  localStorage.setItem("user_data", JSON.stringify(updatedData));

  return updatedData;
};

export const customSelectStyles = {
  control: (provided) => ({
    ...provided,
    border: "1px solid #ababab",
    borderRadius: "12px",
    boxShadow: "none",
    backgroundColor: "transparent",
  }),

  // 👇 Menu ka background ek hi color
  menu: (provided) => ({
    ...provided,
    backgroundColor: theme === "light" ? "#F0F2F8" : "#181818",
    borderRadius: "12px",
    boxShadow: "0 4px 10px rgba(0, 0, 0, 0.1)", // subtle shadow
    padding: "4px 0",
  }),

  // 👇 Options ke liye hover aur normal state alag
  option: (provided, state) => ({
    ...provided,
    backgroundColor: state.isFocused
      ? theme === "light"
        ? "#e2e2e4ff" // light hover
        : "#2a2a2a" // dark hover
      : "transparent", // normal transparent
    color: theme === "light" ? "#111" : "#fff",
    cursor: "pointer",
    padding: "10px 14px",
    borderRadius: "4px",
    transition: "background-color 0.2s ease",
  }),
};

export const truncateString = (str, maxLength = 22) => {
  if (str.length > maxLength) {
    return str.slice(0, maxLength - 3) + "...";
  }
  return str;
}

// CustomTooltip.jsx
export const CustomTooltip = (props) => {
  return (
    <div
      style={{
        background: "black",
        color: "white",
        padding: "4px 8px",
        borderRadius: "4px",
        fontSize: "12px",
        boxShadow: "0 2px 6px rgba(0,0,0,0.3)",
      }}
    >
      {props.value}
    </div>
  );
}

// URL ko Base64 me convert karne ka helper
export const getBase64FromImageUrl = (url) => {
  return new Promise((resolve, reject) => {
    const img = new Image();
    img.crossOrigin = "anonymous"; // important for CORS
    img.src = url;

    img.onload = () => {
      const canvas = document.createElement("canvas");
      canvas.width = img.width;
      canvas.height = img.height;
      const ctx = canvas.getContext("2d");
      ctx.drawImage(img, 0, 0);
      resolve(canvas.toDataURL("image/png")); // base64 mil gaya
    };

    img.onerror = (err) => reject(err);
  });
};

export const getStepSize = (maxValue) => {
  return Math.ceil(maxValue / 10);
}

// number -> "2,45,678"
export const formatIndianAmountType = (num) => {
  if (num === null || num === undefined) return "";
  return Number(num).toLocaleString("en-IN");
};

/*

icon: "🎉", title: "Festival", subtitle: "Celebrate holidays" },
  { icon: "🎂", title: "Birthday", subtitle: "Team birthdays" },
  { icon: "🎊", title: "Work Anniversary", subtitle: "Milestone celebrations" },
  { icon: "⭐", title: "Employee Appreciation", subtitle: "Recognition posts" },
  { icon: "👋", title: "Onboarding", subtitle: "Welcome new hires" },
  { icon: "🚀", title: "Sales/Promotion", subtitle: "Business updates" },
  { icon: "📝", title: "General Announcement", subtitle: "Company-wide updates" },
  { icon: "📢",

*/
export const generateSNoOnj = (employees) => {
  const updatedEmployees = employees.map((emp, index) => ({
    ...emp,
    serialNumber: index + 1
  }));
  return updatedEmployees
}


// export {
//   compressImage,
//   scrollBottom,
//   getDaysInMonth,
//   getDayName,
//   dropdownFunc,
//   checkLength,
//   convertPDFToBase64,
//   customStyles,
//   ISOTimeFormat,
//   getFileExtension,
//   getFormattedAttendance,
//   getFormattedUsers,
//   downloadCSV,
//   getCurrentDate,
//   getCapitalizeWord,
//   getFormattedAttendanceCSV,
//   months,
//   getEmployeeFormattedData,
//   splitMonthIntoWeeks,
//   geolocationStatus,
//   convertJSONToCSV,
//   downloadCSV1,
//   splitWaypoints,
//   getUniqueLocations,
//   getSnapToRoadsWayPoints,
//   splitCamelCase,
//   getInitials,
//   getInitialColor,
//   getDateWithMonthName,
//   formattedAttDashboard,
//   formattedReport,
//   getMonthDatesFormatted,
//   getFormattedMonthlyAttendance,
//   getFormattedToday,
//   getFormattedDate,
//   generateTimeSlots,
//   getRemainingDatesInMonth,
//   isCurrentMonth,
//   getFormattedPaymentHistory,
//   getMonth,
//   getAttendanceFormattedData,
//   imageToBase64,
//   csvDataWithNestedObject,
//   getEmployeeFormattedDataOne,
//   getBarChartFormattedData,
//   getDoughnutChartFormattedData,
//   darkModeStyle,
//   notificationTitle,
//   getTitleBtn,
//   downloadAsPdf,
//   generateForm22Doc,
//   exportToExcel,
//   exportToTrackerExcel,
//   downloadPdf,
//   formattedRunPayrollSalarySlip,
//   formatDate,
//   trackerDataFormat,
//   downloadForm22Excel,
//   getMonthlyAttendanceInExcelFormat,
//   formatDateToMonthYear,
//   formatDateWithLongMonth,
//   getGreterDate,
//   totalAmountOfAllowance,
//   updateUserData,
//   customSelectStyles,
//   convertToBase64,
//   truncateString,
//   CustomTooltip,
//   getBase64FromImageUrl,
//   getStepSize,
//   formatHeader,
//   formatIndianAmountType,
//   generateSNoOnj
// };
